import React, { useState } from 'react';
import { LoadingGrid } from '../../../../rbts/helpers/components/LoadingGrid';


type Props = {};

const View: React.FC<Props> = () => {
    const url = process.env.REACT_APP_URL_STATUS_CHATBOT;

    const [loading, setLoading] = useState(true);

  return (
    <div style={{ width: "100%", height: "100vh", position: "relative" }}>
        {loading && (
        <LoadingGrid text="Cargando..."></LoadingGrid>
      )}

      <iframe title='Página de estatus del chat'
        src={url}
        style={{ width: "100%", height: "100%", border: "none" }}
        onLoad={() => setLoading(false)}
      />
    </div>
  );
};

export { View };
